<mat-toolbar class="fullscreen-toolbar" color="primary" mat-dialog-title>
  <h3 class="chooser-header">
    Add {{ 'scheduler.setup.planners.title' | translate }}
  </h3>

  <span class="spacer"></span>
  <button (click)="onCancelClick()" mat-icon-button>
    <mat-icon fontIcon="fa-window-close" fontSet="fas"></mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="fullscreen-dialog">
  <mat-selection-list #plannerSelect>
    @for (planner of plannerList; track planner) {
      <mat-list-option [value]="planner">
        {{ planner.displayName }}
      </mat-list-option>
    }
  </mat-selection-list>
  @if (!plannerList || plannerList.length===0) {
    <div>
      <div class="container">
        <div class="row">
          {{ 'scheduler.resource-detail.no-options' | translate }}
        </div>
        <div class="row">
        </div>
      </div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <span class="spacer"></span>
  <button (click)="onCancelClick()" mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
  <button (click)="onSelectClick()" [disabled]="plannerSelect.selectedOptions.selected.length===0" color="primary"
    mat-raised-button>{{ 'scheduler.general.select' | translate }}
  </button>
  <!--  <button mat-raised-button color="primary" [disabled]="" (click)="onDeleteSelect()" > {{ 'scheduler.general.setup' | translate }}</button>-->
</mat-dialog-actions>